const getters = {
  token: state => state.user.accessToken,
  avatar: state => state.user.avatar,
  nick_name: state => state.user.nick_name,
  user_name: state => state.user.user_name,
  roles: state => state.user.roles,
  user_id: state => state.user.user_id,
  current_team_id: state => state.user.current_team_id,
  current_team: state => state.user.current_team,
  current_team_ver: state => state.user.current_team_ver,
  email: state => state.user.email,
  user_point: state => state.user.user_point,
  themeMode: state => state.theme.themeMode,
  actualTheme: state => state.theme.actualTheme,
  systemTheme: state => state.theme.systemTheme,
  user_sub: state => state.user.user_sub
}
export default getters
